export const INITIALIZE_START = 'INITIALIZE_START';
export const INITIALIZE_END = 'INITIALIZE_END';

// export const FETCH_TODO_LIST = 'FETCH_TODO_LIST';
export const ADD_TODO = 'ADD_TODO';
export const DELETE_TODO = 'DELETE_TODO';
export const MODIFY_TODO = 'MODIFY_TODO';
export const FILTER_TODO_LIST = 'FILTER_TODO_LIST';